import React from "react";
import Image from "next/image";
import { isNotionProxy } from "@/lib/image";
import Link from "next/link";
import { Slugify } from "@/utils/slugify";

interface PostCardProps {
  thumbnail?: string | null;
  title: string;
  description: string;
  writerPicture: string | null;
  writerName: string | null;
  date: Date;
}

function PostCard({
  thumbnail,
  title,
  description,
  writerPicture,
  writerName,
  date,
}: PostCardProps) {
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  return (
    <Link
      href={`/article/${Slugify(title)}`}
      className="flex flex-col items-center justify-center rounded-xl gap-3 p-[18px] bg-natura-lighter-2 hover:bg-natura-lighter-1 transition-all duration-300 ease-out min-w-[253px] min-h-[295px] sm:min-w-[292px] sm:min-h-[381px]"
    >
      <div className="relative w-full h-[129px] sm:h-[180px]">
        <Image
          src={thumbnail ?? ""}
          unoptimized={isNotionProxy(thumbnail)}
          alt=""
          fill
          className="object-center object-cover rounded-[10px]"
        />
      </div>

      <p className="text-base/snug sm:text-[24px]/[140%] font-serifText text-natura-darker-1 line-clamp-2">
        {title}
      </p>
      <p className="text-xs/normal sm:text-[14px]/[150%] font-nunito line-clamp-3">
        {description}
      </p>

      <div className="flex flex-row gap-[6px] justify-start items-center w-full">
        {/* Image placeholder */}
        <div className="relative size-5 sm:size-[25px] ">
          {writerPicture ? (
            <Image
              src={writerPicture}
              unoptimized={isNotionProxy(writerPicture)}
              fill
              alt=""
              className="object-cover object-center rounded-full"
            />
          ) : (
            <div className="w-full h-full rounded-full p-2 flex items-center justify-center bg-natura-darker-1">
              <p className="font-nunito text-[10px] md:text-sm/normal fomt-bold text-natura-white">
                {writerName?.slice(0, 1).toUpperCase()}
              </p>
            </div>
          )}
        </div>
        <p className="text-[10px]/[150%] sm:text-[12px]/[150%] font-bold font-nunito text-nowrap">
          {writerName
            ? writerName.length > 18
              ? writerName.slice(0, 18) + "..."
              : writerName
            : "Unknown"}
        </p>
        <p className="text-[10px]/[150%] sm:text-[12px]/[150%] font-bold font-nunito">
          -
        </p>
        <p className="text-[10px]/[150%] sm:text-[12px]/[150%] font-nunito text-nowrap">
          {day} {month} {year}
        </p>
      </div>
    </Link>
  );
}

export default PostCard;
